import { PwInput } from "@/components/ui/pw-input";
import { useState } from "react";
import { Loader2, PackageCheck } from "lucide-react";
import { papi, setToken, errText } from "./portalApi";

export const PortalLogin = ({ onIn }) => {
  const [f, setF] = useState({ code: "", password: "" });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const go = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      const r = await papi("post", "/auth/login", f);
      setToken(r.token);
      onIn(r.partner);
    } catch (x) { setErr(errText(x)); } finally { setBusy(false); }
  };
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0f1c2e] px-4" data-testid="portal-login">
      <form onSubmit={go} className="w-full max-w-sm rounded-2xl bg-white p-7 shadow-2xl">
        <div className="mb-6 flex items-center gap-3">
          <div className="grid h-11 w-11 place-items-center rounded-xl bg-teal-600 text-white"><PackageCheck className="h-6 w-6" /></div>
          <div><h1 className="text-xl font-bold text-slate-900">Order Portal</h1><p className="text-xs text-slate-500">Sign in with your client code</p></div>
        </div>
        <label className="block text-xs font-semibold text-slate-600">Client code
          <input value={f.code} onChange={(e) => setF({ ...f, code: e.target.value.toUpperCase() })} autoCapitalize="characters"
            className="mt-1 w-full rounded-lg border px-3 py-2.5 font-mono text-sm uppercase outline-none focus:border-teal-600" data-testid="portal-login-code" /></label>
        <label className="mt-3 block text-xs font-semibold text-slate-600">Password
          <PwInput value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })}
            className="mt-1 w-full rounded-lg border px-3 py-2.5 text-sm outline-none focus:border-teal-600" data-testid="portal-login-password" /></label>
        {err && <p className="mt-3 rounded-lg bg-rose-50 px-3 py-2 text-xs text-rose-700" data-testid="portal-login-error">{err}</p>}
        <button disabled={busy || !f.code || !f.password} className="mt-5 flex w-full items-center justify-center gap-2 rounded-lg bg-teal-600 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-teal-700 disabled:opacity-50" data-testid="portal-login-submit">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />} Sign in</button>
        <p className="mt-4 text-center text-[11px] text-slate-400">Forgot your password? Ask the office to reset it.</p>
      </form>
    </div>
  );
};
